export const INITIAL_VALUES = {
  legalCompanyName: "", dba: "", primaryContact: "", title: "", email: "", phone: "",
  businessAddress: "", city: "", state: "", zip: "", country: "", businessType: "",
  otherBusinessType: "", ein: "", formationState: "", remittanceEmail: "",
  paymentMethod: "", bankName: "", accountNumber: "", routingNumber: "", swiftCode: "",
  paymentTerms: "", otherPaymentTerms: "",
};
export type AgencyRegistrationValues = typeof INITIAL_VALUES;
export type AgencyFieldKey = keyof AgencyRegistrationValues;
export interface AgencyField {
  key: AgencyFieldKey;
  label: string;
  placeholder: string;
  type?: "email" | "tel";
  wide?: boolean;
}
export const AGENCY_FIELDS: AgencyField[] = [
  { key: "legalCompanyName", label: "Legal Company Name", placeholder: "Enter Legal Company Name" },
  { key: "dba", label: "DBA (if applicable)", placeholder: "Enter DBA Name" },
  { key: "primaryContact", label: "Primary Agency Contact Name", placeholder: "Enter Contact Name" },
  { key: "title", label: "Title", placeholder: "Enter Title" },
  { key: "email", label: "Email Address", placeholder: "name@agency.com", type: "email" },
  { key: "phone", label: "Phone Number", placeholder: "Enter Phone Number", type: "tel" },
  { key: "businessAddress", label: "Business Address", placeholder: "Street address, suite or building", wide: true },
  { key: "city", label: "City", placeholder: "Enter City" },
  { key: "state", label: "State / Province", placeholder: "Enter State or Province" },
  { key: "zip", label: "ZIP / Postal Code", placeholder: "Enter ZIP or Postal Code" },
  { key: "country", label: "Country", placeholder: "Enter Country" },
];
export const TAX_FIELDS: AgencyField[] = [
  { key: "ein", label: "Tax ID (EIN)", placeholder: "Enter Employer Identification Number" },
  { key: "formationState", label: "State of Incorporation / Formation", placeholder: "Enter State of Incorporation or Formation" },
  { key: "remittanceEmail", label: "Accounts Payable / Remittance Email", placeholder: "accounts@agency.com", type: "email", wide: true },
];
export const BANK_FIELDS: AgencyField[] = [
  { key: "bankName", label: "Bank Name", placeholder: "Enter Bank Name" },
  { key: "accountNumber", label: "Account Number", placeholder: "Enter Account Number" },
  { key: "routingNumber", label: "Routing Number", placeholder: "Enter Routing Number" },
  { key: "swiftCode", label: "SWIFT Code (if international)", placeholder: "Enter SWIFT / BIC code" },
];
export const BUSINESS_TYPES = [
  { value: "llc", label: "LLC" }, { value: "corporation", label: "Corporation" },
  { value: "partnership", label: "Partnership" }, { value: "other", label: "Other" },
];
export const PAYMENT_METHODS = [
  { value: "ach", label: "ACH / Direct Deposit" }, { value: "wire", label: "Wire Transfer" }, { value: "check", label: "Check" },
];
export const PAYMENT_TERMS = [
  { value: "net15", label: "Net 15" }, { value: "net30", label: "Net 30" },
  { value: "net45", label: "Net 45" }, { value: "other", label: "Other" },
];
export const OTHER_BUSINESS_FIELD: AgencyField = { key: "otherBusinessType", label: "Other Business Type", placeholder: "Specify your business type" };
export const OTHER_TERMS_FIELD: AgencyField = { key: "otherPaymentTerms", label: "Other Payment Terms", placeholder: "Specify the payment terms" };
export const AUTHORIZATION = "I certify that the information provided above is accurate and complete and that the agency is authorized to provide the identified consultant for the engagement described. I understand that onboarding is subject to completion of required agreements, documentation, compliance requirements, and project approvals.";
